import styles from "./checkout.module.css";
import { useCheckout } from "./checkout-provider";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { useImageStore } from "entity-store/image-store/use-image-store";
import { useEffect } from "react";
import { useProjectStore } from "entity-store/project-store/use-project-store";
import { usePaths } from "BEDROCK/paths";
import { useState } from "react";

type CheckoutState = "empty" | "loading" | "ready" | "processing" | "error";

interface CheckoutProps {}

export const Checkout = (props: CheckoutProps) => {
  const [state, setState] = useState<CheckoutState>("loading");

  const { navigateTo, home, processOrder, postCheckout } = usePaths();

  const { loadProject } = useProjectStore();

  const { checkout, clearCheckout, pay } = useCheckout();

  useEffect(() => {
    if (checkout.items.length === 0) {
      setState("empty");
    }
  }, []);

  const proceed = () => {
    pay().catch((error) => {
      console.error("Error during payment:", error);
      setState("error");
    });
  };

  return (
    <div className={styles.container}>
      <h1>Checkout</h1>
      <p>Checkout state: {state}</p>
      <CTAButton variant="SECONDARY" onClick={clearCheckout}>
        Clear Checkout
      </CTAButton>
      <CTAButton variant="SECONDARY" onClick={proceed}>
        Pay
      </CTAButton>
    </div>
  );
};
